

// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { addBanner, fetchBanners } from "../../redux/actions/bannerActions";
// import toast from "react-hot-toast"; 

// const AddBanner = ({ onClose }) => {
//   const dispatch = useDispatch();
//   const [bannerType, setBannerType] = useState("topBanners");
//   const [images, setImages] = useState([]);
//   const [imageError, setImageError] = useState(""); // For image validation errors

//   // Handle file input change and validate based on banner type
//   const handleFileChange = (event) => {
//     const selectedFiles = Array.from(event.target.files);
//     const validFileTypes = ['image/jpeg', 'image/png'];
//     const maxSize = 200 * 1024; // 200KB

//     let errorMessage = "";
//     if (bannerType === "topBanners" && selectedFiles.length > 4) {
//       errorMessage = "You can upload a maximum of 4 images for Top Banner.";
//     } else if (bannerType === "midBanners" && selectedFiles.length > 1) {
//       errorMessage = "You can only upload 1 image for Mid Banner.";
//     } else if (bannerType === "bottomBanners" && selectedFiles.length > 1) {
//       errorMessage = "You can only upload 1 image for Bottom Banner.";
//     } else {
//       for (let file of selectedFiles) {
//         if (!validFileTypes.includes(file.type)) {
//           errorMessage = "Only JPG and PNG files are allowed.";
//           break;
//         } else if (file.size > maxSize) {
//           errorMessage = "Each image must be less than 200KB.";
//           break;
//         }
//       }
//     }

//     if (errorMessage) {
//       setImageError(errorMessage);
//     } else {
//       setImageError(""); // Clear any previous error
//       setImages(selectedFiles);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (imageError) {
//       toast.error(imageError);
//       return;
//     }

//     const formData = new FormData();
//     images.forEach((image) => formData.append("images", image));

//     // Dispatch addBanner action
//     dispatch(addBanner(formData, bannerType)).then(() => {
//       // Fetch updated banners after successfully adding a new banner
//       dispatch(fetchBanners());

//       // Show success toast notification
//       toast.success("Banner added successfully!");

//       // Close the modal
//       onClose();
//     }).catch(() => {
//       // Show error toast notification in case of failure
//       toast.error("Failed to add banner.");
//     });
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//       <div className="bg-white p-6 rounded-lg">
//         <h2 className="text-xl font-bold mb-4">Add Banner</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-gray-700 font-bold mb-2">
//               Select Banner Type
//             </label>
//             <select
//               value={bannerType}
//               onChange={(e) => setBannerType(e.target.value)}
//               className="w-full border p-2 rounded"
//             >
//               <option value="topBanners">Top Banner</option>
//               <option value="midBanners">Mid Banner</option>
//               <option value="bottomBanners">Bottom Banner</option>
//             </select>
//           </div>

//           <div className="mb-4">
//             <label className="block text-gray-700 font-bold mb-2">
//               Upload Images
//             </label>
//             <input
//               type="file"
//               multiple={bannerType === "topBanners"} // Allow multiple files only for "topBanners"
//               onChange={handleFileChange}
//               className="w-full"
//             />
//             {imageError && <p className="text-red-500 text-sm">{imageError}</p>}
//           </div>

//           {/* Display different messages based on banner type */}
//           <div className="text-sm text-gray-500">
//             {bannerType === "topBanners" && (
//               <p>Max 4 images (JPG/PNG, max size: 200KB each)</p>
//             )}
//             {bannerType === "midBanners" && (
//               <p>1 image (JPG/PNG, max size: 200KB)</p>
//             )}
//             {bannerType === "bottomBanners" && (
//               <p>1 image (JPG/PNG, max size: 200KB)</p>
//             )}
//           </div>

//           <div className="mt-4 flex justify-between items-center">
//             <button
//               type="submit"
//               className="bg-blue-500 text-white px-4 py-2 rounded"
//             >
//               Upload
//             </button>
//             <button
//               type="button"
//               className="bg-gray-500 text-white px-4 py-2 rounded ml-2"
//               onClick={onClose}
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddBanner;


// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { addBanner, fetchBanners } from "../../redux/actions/bannerActions";
// import toast from "react-hot-toast";

// const AddBanner = ({ onClose }) => {
//   const dispatch = useDispatch();
//   const [bannerType, setBannerType] = useState("topBanners");
//   const [images, setImages] = useState([]);
//   const [imageError, setImageError] = useState("");

//   // Handle file input change and validate based on banner type
//   const handleFileChange = (event) => {
//     const selectedFiles = Array.from(event.target.files);
//     const validFileTypes = ["image/jpeg", "image/png"];
//     const maxSize = 200 * 1024; // 200KB

//     let errorMessage = "";
//     if (bannerType === "topBanners" && selectedFiles.length > 4) {
//       errorMessage = "You can upload a maximum of 4 images for Top Banner.";
//     } else if (bannerType === "midBanners" && selectedFiles.length > 1) {
//       errorMessage = "You can only upload 1 image for Mid Banner.";
//     } else if (bannerType === "bottomBanners" && selectedFiles.length > 1) {
//       errorMessage = "You can only upload 1 image for Bottom Banner.";
//     } else {
//       for (let file of selectedFiles) {
//         if (!validFileTypes.includes(file.type)) {
//           errorMessage = "Only JPG and PNG files are allowed.";
//           break;
//         } else if (file.size > maxSize) {
//           errorMessage = "Each image must be less than 200KB.";
//           break;
//         }
//       }
//     }

//     if (errorMessage) {
//       setImageError(errorMessage);
//     } else {
//       setImageError(""); // Clear any previous error
//       setImages(selectedFiles);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (imageError) {
//       toast.error(imageError);
//       return;
//     }

//     const formData = new FormData();
//     images.forEach((image) => formData.append("images", image));

//     // Dispatch addBanner action
//     dispatch(addBanner(formData, bannerType))
//       .then(() => {
//         // Fetch updated banners after successfully adding a new banner
//         dispatch(fetchBanners());

//         // Show success toast notification
//         toast.success("Banner added successfully!");

//         // Close the modal
//         onClose();
//       })
//       .catch(() => {
//         // Show error toast notification in case of failure
//         toast.error("Failed to add banner.");
//       });
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//       <div className="w-11/12 max-w-2xl mx-auto bg-white rounded-lg shadow-xl overflow-hidden">
//         {/* Modal Header */}
//         <div className="p-4 border-b">
//           <h2 className="text-xl font-bold text-gray-800">Add Banner</h2>
//           <button
//             onClick={onClose}
//             className="absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-700 transition-colors"
//           >
//             <svg
//               className="w-6 h-6"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </button>
//         </div>

//         {/* Modal Body */}
//         <div className="p-4 space-y-6">
//           {/* Banner Type Selection */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Select Banner Type
//             </label>
//             <select
//               value={bannerType}
//               onChange={(e) => setBannerType(e.target.value)}
//               className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//             >
//               <option value="topBanners">Top Banner</option>
//               <option value="midBanners">Mid Banner</option>
//               <option value="bottomBanners">Bottom Banner</option>
//             </select>
//           </div>

//           {/* File Upload */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Upload Images
//             </label>
//             <div className="flex items-center justify-center w-full border-2 border-dashed border-gray-300 rounded-lg p-6 transition-colors hover:border-blue-500">
//               <input
//                 type="file"
//                 multiple={bannerType === "topBanners"}
//                 onChange={handleFileChange}
//                 className="hidden"
//                 id="file-upload"
//               />
//               <label
//                 htmlFor="file-upload"
//                 className="cursor-pointer text-center"
//               >
//                 <svg
//                   className="w-8 h-8 mx-auto text-gray-400"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
//                   />
//                 </svg>
//                 <p className="text-sm text-gray-500 mt-2">
//                   Drag and drop files here or{" "}
//                   <span className="text-blue-500 hover:text-blue-700">
//                     browse
//                   </span>
//                 </p>
//               </label>
//             </div>
//             {imageError && (
//               <p className="text-red-500 text-sm mt-2">{imageError}</p>
//             )}
//           </div>

//           {/* File Requirements */}
//           <div className="text-sm text-gray-500">
//             {bannerType === "topBanners" && (
//               <p>Max 4 images (JPG/PNG, max size: 200KB each)</p>
//             )}
//             {bannerType === "midBanners" && (
//               <p>1 image (JPG/PNG, max size: 200KB)</p>
//             )}
//             {bannerType === "bottomBanners" && (
//               <p>1 image (JPG/PNG, max size: 200KB)</p>
//             )}
//           </div>
//         </div>

//         {/* Modal Footer */}
//         <div className="flex justify-end gap-3 p-4 border-t">
//           <button
//             type="button"
//             onClick={onClose}
//             className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             onClick={handleSubmit}
//             className="px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
//           >
//             Upload
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddBanner;



import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addBanner, fetchBanners } from "../../redux/actions/bannerActions";
import toast from "react-hot-toast";

const AddBanner = ({ onClose }) => {
  const dispatch = useDispatch();
  const [bannerType, setBannerType] = useState("topBanners");
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [imageError, setImageError] = useState("");

  // Handle file input change and validate based on banner type
  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const validFileTypes = ["image/jpeg", "image/png"];
    const maxSize = 200 * 1024; // 200KB

    let errorMessage = "";
    if (bannerType === "topBanners" && selectedFiles.length > 4) {
      errorMessage = "You can upload a maximum of 4 images for Top Banner.";
    } else if (bannerType === "midBanners" && selectedFiles.length > 1) {
      errorMessage = "You can only upload 1 image for Mid Banner.";
    } else if (bannerType === "bottomBanners" && selectedFiles.length > 1) {
      errorMessage = "You can only upload 1 image for Bottom Banner.";
    } else {
      for (let file of selectedFiles) {
        if (!validFileTypes.includes(file.type)) {
          errorMessage = "Only JPG and PNG files are allowed.";
          break;
        } else if (file.size > maxSize) {
          errorMessage = "Each image must be less than 200KB.";
          break;
        }
      }
    }

    if (errorMessage) {
      setImageError(errorMessage);
    } else {
      setImageError(""); // Clear any previous error
      setImages(selectedFiles);

      // Generate image previews
      const previews = selectedFiles.map((file) => URL.createObjectURL(file));
      setImagePreviews(previews);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (imageError) {
      toast.error(imageError);
      return;
    }

    const formData = new FormData();
    images.forEach((image) => formData.append("images", image));

    // Dispatch addBanner action
    dispatch(addBanner(formData, bannerType))
      .then(() => {
        // Fetch updated banners after successfully adding a new banner
        dispatch(fetchBanners());

        // Show success toast notification
        toast.success("Banner added successfully!");

        // Close the modal
        onClose();
      })
      .catch(() => {
        // Show error toast notification in case of failure
        toast.error("Failed to add banner.");
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-11/12 max-w-2xl mx-auto bg-white rounded-lg shadow-xl overflow-hidden">
        {/* Modal Header */}
        <div className="p-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Add Banner</h2>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-700 transition-colors"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-4 space-y-6">
          {/* Banner Type Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Banner Type
            </label>
            <select
              value={bannerType}
              onChange={(e) => setBannerType(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="topBanners">Top Banner</option>
              <option value="midBanners">Mid Banner</option>
              <option value="bottomBanners">Bottom Banner</option>
            </select>
          </div>

          {/* File Upload */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload Images
            </label>
            <div className="flex items-center justify-center w-full border-2 border-dashed border-gray-300 rounded-lg p-6 transition-colors hover:border-blue-500">
              <input
                type="file"
                multiple={bannerType === "topBanners"}
                onChange={handleFileChange}
                className="hidden"
                id="file-upload"
              />
              <label
                htmlFor="file-upload"
                className="cursor-pointer text-center"
              >
                <svg
                  className="w-8 h-8 mx-auto text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                  />
                </svg>
                <p className="text-sm text-gray-500 mt-2">
                  Drag and drop files here or{" "}
                  <span className="text-blue-500 hover:text-blue-700">
                    browse
                  </span>
                </p>
              </label>
            </div>
            {imageError && (
              <p className="text-red-500 text-sm mt-2">{imageError}</p>
            )}
          </div>

          {/* Display selected image previews */}
          <div className="mt-4 grid grid-cols-2 gap-4">
            {imagePreviews.map((preview, index) => (
              <div key={index} className="w-24 h-24 bg-gray-100 flex justify-center items-center">
                <img src={preview} alt={`preview-${index}`} className="w-full h-full object-cover rounded" />
              </div>
            ))}
          </div>

          {/* File Requirements */}
          <div className="text-sm text-gray-500">
            {bannerType === "topBanners" && (
              <p>Max 4 images (JPG/PNG, max size: 200KB each)</p>
            )}
            {bannerType === "midBanners" && (
              <p>1 image (JPG/PNG, max size: 200KB)</p>
            )}
            {bannerType === "bottomBanners" && (
              <p>1 image (JPG/PNG, max size: 200KB)</p>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="flex justify-end gap-3 p-4 border-t">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            className="px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBanner;
